import createAdjDetailHarness from './createAdjDetailHarness'
import getAdjReason from './getAdjReason'
import calcSkillAdjTotals from './calcSkillAdjTotals'
//--------------------------
// load specific skill adjs
//--------------------------{
export default function loadSpecificSkillAdjs({ skill, character } = {}) {
  console.log('==============================================================')
  console.log(
    'IN LOAD SPECIFIC SKILL ADJS SKILL NAME = ',
    skill.name,
    ' display_name = ',
    skill.display_name,
  )
  // console.log('==============================================================')
  console.log('skill = ', window.$deepCopy(skill))
  // console.log('A. skill.character_skill_adjs:', window.$deepCopy(skill.character_skill_adjs))
  // console.log(
  //   'B. skill.characteristic_skill_adjs:',
  //   window.$deepCopy(skill.characteristic_skill_adjs),
  // )
  // console.log(
  //   'C. skill.integrated_rune_skill_adjs:',
  //   window.$deepCopy(skill.integrated_rune_skill_adjs),
  // )
  //----------------------------------------------------------------------------------------------
  /* create createAdjDetailEntry from the following:

    A. character.skills.character_skill_adjs e.g. +10 Stealth [CharacterSkillAdjs] ... split for applied & optional adjs
    B. character.skills.characteristic_skill_adjs e.g. -5 armour dex pen [CharacteristicSkillAdjs]
    C. character.skills.integrated_rune_skill_adjs e.g. +5 Stealth from Shadow Rune [RuneSkillAdjs]

    NB: reasons are stored with the skill object
    NB: totals are already stored on skill object from download
  */
  //----------
  // get args
  //----------
  skill = skill ?? {}
  character = character ?? {}
  //-----------------
  // get adjs arrays
  //-----------------
  skill.character_skill_adjs = skill.character_skill_adjs || []
  skill.characteristic_skill_adjs = skill.characteristic_skill_adjs || []
  skill.integrated_rune_skill_adjs = skill.integrated_rune_skill_adjs || []
  //---------------------------------------
  // need to reset totals for runecasting (as dont reflect integrated rune adjs for runecasting)
  //---------------------------------------
  if (skill.name === 'Runecasting') {
    // set total adjs to character + characteristic adjs only - exclude integrated rune skill adjs
    skill.adjs_tot = skill.adjs_tot_character_skill + skill.adjs_tot_characteristic_skill
    // reset integrated rune skill adjs. will be recalculated here to allow for all_in_type adjs e.g. magic runecasting
    skill.adjs_tot_integrated_rune_skill = 0
  }
  //===========================================================================================
  // A. loop character skills e.g. +15 Brute Force (none for new skill)
  //--------------------------------------------------------------------
  skill.character_skill_adjs.forEach((a) => {
    console.log('-----------------------------------------------------')
    console.log('+++++++ A. CHARACTER SKILL ADJ = ', a)
    //------------------------------------
    // where reason exists for this skill
    //------------------------------------
    if (a.adj_reason != '') {
      //---------------------
      // build reason string
      //---------------------
      let reason = getAdjReason(a.adj_reason, a.adj_value)
      //----------------------
      // where applied = true
      //----------------------
      if (a.applied) {
        //----------------------------------------------------------
        // set or append top-level reasons for this skill (applied)
        //----------------------------------------------------------
        if (skill['adjs_reasons_character_skill']) {
          skill['adjs_reasons_character_skill'] += '. ' + reason
        } else {
          skill['adjs_reasons_character_skill'] = reason
        }
        //-----------------------
        // where applied = false
        //-----------------------
      } else {
        //-----------------------------------------------------------
        // set or append top-level reasons for this skill (optional)
        //-----------------------------------------------------------
        if (skill['adjs_reasons_character_skill_opt']) {
          skill['adjs_reasons_character_skill_opt'] += '. ' + reason
        } else {
          skill['adjs_reasons_character_skill_opt'] = reason
        }
      }
    }
    //--------------------------------------------
    // create adj detail entry for this skill adj
    //--------------------------------------------
    const adj_entry = createAdjDetailHarness({
      adj: a,
      adjs: character.skill_adjs,
      source: 'character',
      character,
      applied: a.applied || false,
    })
    //---------------
    // add adj entry
    //---------------
    if (adj_entry) {
      console.log('+++++++++ A. CREATED CHARACTER SKILL ADJ ENTRY = ', adj_entry)
      character.skill_adjs.push(adj_entry)
    } else {
      console.info(
        'A. loadSpecificSkillAdjs: character skill adj detail entry already existed, so no new entry was created for adj = ',
        a,
      )
    }
  })
  //===========================================================================================
  // B. loop characteristic skill adjs e.g. -5 armour dex pen (impacting stealth as dex-based)
  //-------------------------------------------------------------------------------------------
  skill.characteristic_skill_adjs.forEach((b) => {
    console.log('-----------------------------------------------------')
    console.log('+++++++ B. CHARACTERISTIC SKILL ADJ = ', b)
    console.log('1. b.characteristic_name = ', b.characteristic_name)
    console.log('2. skill.name = ', skill.name)
    //------------------------------------
    // where reason exists for this skill
    //------------------------------------
    if (b.adj_reason != '') {
      //---------------------
      // build reason string
      //---------------------
      let reason = getAdjReason(b.adj_reason, b.adj_value)
      //------------------------------------------------
      // set or append top-level reasons for this skill
      //------------------------------------------------
      if (skill['adjs_reasons_characteristic_skill']) {
        skill['adjs_reasons_characteristic_skill'] += '. ' + reason
      } else {
        skill['adjs_reasons_characteristic_skill'] = reason
      }
    }
    //--------------------------------------
    // change adj name (blank) to skill name
    //---------------------------------------
    b.name = skill.name ? skill.name : 'Unnamed Skill'
    b.applied = b.applied ?? true
    console.log('3. UPDATED b.name = ', b.name)
    //--------------------------------------------
    // create adj detail entry for this skill adj
    //--------------------------------------------
    const adj_entry = createAdjDetailHarness({
      adj: b,
      adjs: character.skill_adjs,
      source: 'characteristic',
      character,
    })
    //---------------
    // add adj entry
    //---------------
    if (adj_entry) {
      console.log('+++++++++ B. CREATED CHARACTERISTIC SKILL ADJ ENTRY = ', adj_entry)
      character.skill_adjs.push(adj_entry)
    } else {
      console.info(
        'B. loadSpecificSkillAdjs: characteristic skill adj detail entry already existed, so no new entry was created for adj = ',
        b,
      )
    }
  })
  // console.log(
  //   '1234 skill.integrated_rune_skill_adjs = ',
  //   window.$deepCopy(skill.integrated_rune_skill_adjs),
  // )
  //===========================================================================================
  // C. loop integrated rune skill adjs e.g. +5 Stealth from Shadow Rune
  //---------------------------------------------------------------------
  skill.integrated_rune_skill_adjs.forEach((c) => {
    // Normalise character_item to always be the linked CharacterItem id,
    // regardless of whether the backend sent an id or an { id, name } object.
    if (c && c.character_item && typeof c.character_item === 'object') {
      c.character_item = c.character_item.id ?? null
    }
    console.log('-----------------------------------------------------')
    console.log('+++++++ C. INTEGRATED RUNE SKILL ADJ = ', c)
    console.log('1. c.name = ', c.name)
    console.log('2. skill.display_name = ', skill.display_name)
    console.log('2a. c.display_name = ', c.display_name)
    console.log('2b. c.applied = ', c.applied)
    //----------------------
    // determine entry name for detailed + headline reasons
    // Always anchor on the rune name where available so that
    // reloads show e.g. "Mega Rune (Athletics)" rather than
    // just the skill name "Athletics".
    //----------------------
    const runeBaseName =
      c.rune_name && c.rune_name !== '' ? c.rune_name : skill.display_name || c.name || 'Unknown'

    let entry_name = ''
    if (c.name === 'Runecasting' && runeBaseName !== '') {
      entry_name = runeBaseName
    } else if (c.display_name && c.display_name !== '') {
      // Prefer the adj's own display name when present
      entry_name = `${runeBaseName} (${c.display_name})`
    } else if (skill.display_name && skill.display_name !== runeBaseName) {
      // Fall back to the skill's display name (e.g. Athletics)
      entry_name = `${runeBaseName} (${skill.display_name})`
    } else if (skill.name === 'Runecasting' && c.name && c.name !== runeBaseName) {
      // Safety net for runecasting where name may still be useful
      entry_name = `${runeBaseName} (${c.name})`
    } else {
      entry_name = runeBaseName
    }

    console.log('3. calcd entry_name = ', entry_name)
    console.log('4. c.adj_reason = ', c.adj_reason)
    //=====================================================================
    // C1. where reason exists - set top-level reason for this skill
    //---------------------------------------------------------------
    //---------------------
    // build reason string
    //---------------------
    let reason = getAdjReason(entry_name, c.adj_value)
    console.log('5. total level reason for = ', entry_name, ' = ', reason)
    //-----------------------------------------------------------------
    // set or append top-level reasons for this skill
    // - applied rune adjs -> adjs_reasons_integrated_rune_skill
    // - optional rune adjs -> adjs_reasons_character_skill_opt so they show
    //   in the existing "Optional Adj Reasons (Skill)" column
    //-----------------------------------------------------------------
    if (c.applied) {
      // applied rune adjs → rune reasons field
      if (skill['adjs_reasons_integrated_rune_skill']) {
        skill['adjs_reasons_integrated_rune_skill'] += '. ' + reason
      } else {
        skill['adjs_reasons_integrated_rune_skill'] = reason
      }
    } else {
      // optional rune adjs → reuse character-skill optional reasons field
      if (skill['adjs_reasons_character_skill_opt']) {
        skill['adjs_reasons_character_skill_opt'] += '. ' + reason
      } else {
        skill['adjs_reasons_character_skill_opt'] = reason
      }
    }
    //======================================================================
    // C2. prepare skill adjustment entry
    //-----------------------------------
    //---------------------------
    // where 'Runecasting' skill
    //---------------------------
    if (c.name === 'Runecasting') {
      // calc overall total & integrated rune total for this skill (allows for all_in_type adjs e.g. magic runecasting)
      skill.adjs_tot_integrated_rune_skill += c.adj_value
      skill.adjs_tot += c.adj_value
    }
    // console.log('6. character.skill_adjs = ', window.$deepCopy(character.skill_adjs))
    //---------------------------------------------------
    // create adj detail entry for this (rune) skill adj
    //---------------------------------------------------
    // pass entry_name via adj_reason so detail entry can
    // display e.g. "Air Rune (Jump)" instead of just rune
    c.adj_reason = entry_name
    const adj_entry = createAdjDetailHarness({
      adj: c,
      adjs: character.skill_adjs,
      source: 'integrated_rune',
      character,
    })
    //---------------
    // add adj entry
    //---------------
    if (adj_entry) {
      console.log('+++++++++ C. CREATED INTEGRATED RUNE SKILL ADJ ENTRY = ', adj_entry)
      character.skill_adjs.push(adj_entry)
      // } else {
      //   console.error(
      //     'C. loadSpecificSkillAdjs: failed to create integrated rune skill adj entry for adj = ',
      //     c,
      //   )
    }
  })
  //---------------------------------------------------------------------
  // D. calculate optional adjs count for this skill (all sources)
  //---------------------------------------------------------------------
  if (character && Array.isArray(character.skill_adjs)) {
    const skillName = skill.name || ''
    const skillDisplayName = skill.display_name || ''
    const adjs_cnt_opt = character.skill_adjs.filter((adj) => {
      // match by name or display_name (for safety with runecasting)
      const matchesName =
        adj.name === skillName || (skillDisplayName && adj.name === skillDisplayName)
      return matchesName && adj.applied === false
    }).length

    if (!('adjs_cnt_opt' in skill)) {
      skill.adjs_cnt_opt = adjs_cnt_opt
    } else {
      skill.adjs_cnt_opt = adjs_cnt_opt
    }
    console.log('7. adjs_cnt_opt for skill', skillName, '= ', adjs_cnt_opt)

    //-----------------------------------------------------------------
    // E. recalc applied adj totals for this skill from detail entries
    //     so initial load respects adj.applied flags (incl. optionals)
    //-----------------------------------------------------------------
    const totals = calcSkillAdjTotals({
      category_adjs: character.skill_adjs,
      skill,
      type: skillName,
    })
    skill.adjs_tot = totals.adjs_tot
    skill.adjs_tot_character_skill = totals.adjs_tot_character_skill
    skill.adjs_tot_characteristic_skill = totals.adjs_tot_characteristic_skill
    skill.adjs_tot_integrated_rune_skill = totals.adjs_tot_integrated_rune_skill
    console.log('8. recalced adj totals for skill', skillName, '= ', totals)
  }
  // console.log('XXX skill_adjs = ', window.$deepCopy(character.skill_adjs))
  console.log('END loadSpecificSkillAdjs')
  //-------------------------------------------------------------
  // return mutated objects for clarity (optional use by callers
  //-------------------------------------------------------------
  return { skill, character }
}
